import { ctmTheme } from '@comparethemarketau/manor-themes';

/**
 * Convenience method to obtain a theme object for manor
 * @param {Object} theme - The colors from branding service
 */

// TODO: (28 Oct 2024) @jona get values from CX and Product on what is expected here
// see: https://ctmaus.atlassian.net/wiki/spaces/EN/pages/2628419794/Define+how+Manor+colors+for+other+brands
export const convertBrandingToManorTheme = (theme) => {
    if (!theme.progress_bar_inactive || !theme.progress_bar_active) {
        throw new Error('progress bar branding not provided');
    }

    return (
        {
            ...ctmTheme,
            progress: {
                ...ctmTheme.progress,
                bar: {
                    ...ctmTheme.progress.bar,
                    backgroundValue: theme.progress_bar_inactive,
                    progressBackground: theme.progress_bar_active
                }
            },
            notification: {
                ...ctmTheme.notification,
                general: {
                    ...ctmTheme.notification.general,
                    color: theme.brand_primary
                }
            }
        }
    );
};

/**
 * Convenience method to validate branding service
 * @param {string} everestVertical - The branding service vertical
 * @param {object} payload - The branding service payload
 * @returns {boolean}
 */

export const isValidPayload = (everestVertical, payload) => ['car-insurance', 'home-contents-insurance'].includes(everestVertical)
    && hasTheme(payload)
    && hasContent(everestVertical, payload);

/**
 * Convenience method to get brand theme
 * @param {object} payload - The branding service payload
 * @returns {object} them - The branding content
 */

export const brandTheme = (payload) => (payload?.data?.design_system?.everest);

/**
 * Convenience method to get brand content
 * @param {string} everestVertical - The everest vertical
 * @param {object} payload - The branding service payload
 * @returns {object} content - The branding content
 */

export const brandContent = (everestVertical, payload) => (payload?.data?.vertical[getVerticalOfSchemaKey(everestVertical)]);

/**
 * Convenience method to check payload has expected content
 * @param {string} everestVertical - The everest vertical
 * @param {object} payload - The branding service payload
 * @returns {boolean}
 */

const hasContent = (everestVertical, payload) => (brandContent(everestVertical, payload) !== undefined);

/**
 * Convenience method to check payload has expected theme
 * @param {object} payload - The branding service payload
 * @returns {boolean}
 */

const hasTheme = (payload) => !!payload?.data?.design_system?.everest?.brand_primary;

/**
 * Convenience method to validate branding service
 * @param {string} everestVertical - The everest vertical name
 * @returns {string} the branding service key
 */
const getVerticalOfSchemaKey = (everestVertical) => ({
    'car-insurance': 'car',
    'home-contents-insurance': 'home'
}[everestVertical]);
